import { ClaimRecord, ClaimRecordStatus } from '@typesApp/ClaimRecord'
import { isClosedOrDeletedStatus, isNullifiedStatus } from '@utils/claimUtil'

export const isClaimRecordInProgress = (claimRecord: ClaimRecord | undefined): boolean => {
  if (
    !claimRecord?.status ||
    !claimRecord?.status?.trim() ||
    isNullifiedStatus(claimRecord?.status) ||
    isClosedOrDeletedStatus(claimRecord?.status)
  ) {
    return false
  }

  return claimRecord.status !== ClaimRecordStatus.CLAIM_ACCEPTED && claimRecord.status !== ClaimRecordStatus.RESTRICTED
}
